'use client';

import { useEffect } from 'react';
import {
  ensureVisitorId,
  trackPageLoad,
} from '@nrdy-marketing-engine/tracking/src/trackers/lead-connector-tracker';

/**
 * Client component that initialises lead-connector visitor identity and fires
 * a page_view event on mount. Drop into the root layout alongside the existing
 * <Tracking /> component.
 */
export default function WebAnalytics() {
  useEffect(() => {
    ensureVisitorId();
    trackPageLoad();
  }, []);

  return null;
}
